import { useEffect, useRef, useState } from 'react';
import tablelast from '../../assets/icons/tablelast.svg';
export const getStudentActionMenuOptions = ({
    student,
    handleRowClick,
    handlegenerateIdcard,
    setidcardmodal,
    handlePrintAdmissionForm,
    handleOpenMissingDocumentModal,
    handleCopyPaymentUrl,
    handelAdmissionClose,
    handleRevokeCancellation,
    canRevokeCancellation,
    handleBioMetric
}) => {
    if (!student?.permanent_registration_number) {
        return [];
    }

    if (student?.admission_status === "Cancelled") {
        if (!canRevokeCancellation) {
            return [];
        }
        return [
            {
                label: "Revoke Cancellation",
                icon: <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#7F56DA"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ cursor: 'pointer' }}

                    data-tooltip-id="admission-tip"
                    data-tooltip-content="Revoke Cancellation"
                    title='Revoke Cancellation'
                ><title>Revoke Cancellation</title>
                    <path d="M3 12a9 9 0 1 0 3-6.7" />
                    <polyline points="3 3 3 9 9 9" />
                </svg>,
                onClick: () => handleRevokeCancellation?.(student),
            },
        ];
    }

    return [
        {
            label: "Print ID Card",
            icon: <img
                src={tablelast}
                alt="Options"
                style={{ cursor: 'pointer' }}

                data-tooltip-id="admission-tip" data-tooltip-content="Generate ID Card"
                title='Generate ID Card'
            />,
            onClick: () => {
                handleRowClick(student.user_id);   // ✅ FIX
                handlegenerateIdcard(student.user_id); // ✅ FIX
                setidcardmodal(true);
            },
        },
        // {
        //     label: "Biometric",
        //     icon:
        //         <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
        //             height="23" width="23"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M7 16V11.3615C7 10.8518 7.10026 10.3624 7.28451 9.90769M17 16V12.8154M9.22222 7.73446C10.0167 7.27055 10.9721 7 12 7C14.2795 7 16.2027 8.33062 16.8046 10.15" stroke="#7F56DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M10 17V14.8235M14 17V11.8529C14 10.8296 13.1046 10 12 10C10.8954 10 10 10.8296 10 11.8529V12.6471" stroke="#7F56DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M6 3H3V6" stroke="#7F56DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M18 3H21V6" stroke="#7F56DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M6 21H3V18" stroke="#7F56DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M18 21H21V18" stroke="#7F56DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>,

        //     onClick: () =>
        //         handleBioMetric(student.id, {
        //             original: student,
        //         }),

        // },
        {
            label: "Print Profile",
            icon: <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#7F56DA"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ cursor: 'pointer' }}

                data-tooltip-id="admission-tip"
                data-tooltip-content="Print Admission Form"
                title='Print Admission Form'
            ><title>Print Admission Form</title>
                <path d="M6 9V2h12v7" />
                <path d="M6 18H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2" />
                <rect x="6" y="14" width="12" height="8" />
            </svg>,
            onClick: () => handlePrintAdmissionForm(student),
        },

        // {
        //     label: "Copy",
        //     icon: <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
        //         width="20"
        //         height="20"
        //         style={{ cursor: "pointer" }}

        //     >  <title>Copy Payment Link</title><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M10.0464 14C8.54044 12.4882 8.67609 9.90087 10.3494 8.22108L15.197 3.35462C16.8703 1.67483 19.4476 1.53865 20.9536 3.05046C22.4596 4.56228 22.3239 7.14956 20.6506 8.82935L18.2268 11.2626" stroke="#7F56DA" stroke-width="1.5" stroke-linecap="round"></path> <path d="M13.9536 10C15.4596 11.5118 15.3239 14.0991 13.6506 15.7789L11.2268 18.2121L8.80299 20.6454C7.12969 22.3252 4.55237 22.4613 3.0464 20.9495C1.54043 19.4377 1.67609 16.8504 3.34939 15.1706L5.77323 12.7373" stroke="#7F56DA" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>

        //     ,
        //     onClick: () => handleCopyPaymentUrl(student.user_id),
        // },
        {
            label: "Cancel Admission",
            icon: <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#EF4444"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ cursor: 'pointer' }}

                data-tooltip-id="admission-tip"
                data-tooltip-content="Cancel Admission"

            ><title>Cancel Admission</title>
                <circle cx="12" cy="12" r="10" />
                <line x1="15" y1="9" x2="9" y2="15" />
                <line x1="9" y1="9" x2="15" y2="15" />
            </svg>,
            danger: true,
            onClick: () =>
                handelAdmissionClose(student.user_id, {
                    original: student,
                }),
        },
        {
            label: "Missing Document",
            icon: <svg

                // onClick={() => handleOpenMissingDocumentModal(row.original.id, row)}
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="#7F56DA"
                viewBox="0 0 24 24"
                style={{ cursor: "pointer" }}
                data-tooltip-id="admission-tip"
                data-tooltip-content="Show Missing Documents"
            ><title>Missing Documents</title>
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM6 20V4h7v5h5v11H6z" />
                <circle cx="12" cy="15" r="1.5" />
                <path d="M12 11h.01v2H12z" />
            </svg>,
            onClick: () =>
                handleOpenMissingDocumentModal(student.user_id, {
                    original: student,
                }),
        },
    ];
};
export const ActionMenu = ({ options }) => {
    return (
        <div
            style={{
                display: "flex",
                gap: "5px",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "flex-end",
            }}
        >
            {options.map((item, index) => (
                <div
                    key={index}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",

                        minWidth: "60px",     // 👈 responsive base
                        maxWidth: "65px",
                        flex: "1 0 auto",
                    }}
                >
                    {/* Top color bar */}
                    <span
                        style={{
                            width: "100%",
                            height: "4px",
                            borderRadius: "6px 6px 0 0",
                            backgroundColor: item.color || "#7F56DA",
                        }}
                    />

                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            item.onClick();
                        }}
                        style={{
                            width: "100%",
                            minHeight: "45px",   // 👈 touch friendly
                            height: "65px",
                            padding: "6px 4px",
                            cursor: "pointer",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            borderRadius: "0 0 6px 6px",
                            background: "#fff",
                            border: "none",
                            boxShadow: "0 6px 12px rgba(0,0,0,0.12)",
                            fontSize: "15px",
                        }}
                    >
                        <span style={{ fontSize: "18px" }}>{item.icon}</span>
                        <span
                            style={{
                                fontSize: "12px",
                                color: "#555",
                                textAlign: "center",
                                lineHeight: "1.2",
                                display: "-webkit-box",
                                WebkitLineClamp: 2,          // ✅ max 2 lines
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {item.label}
                        </span>
                    </button>
                </div>
            ))}
        </div>
    );
};
